/**
 * @generated SignedSource<<f6ad3d2190c2a63bb12b90a082b62a07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type proGrantMutationsRevokeProMutation$variables = {
  reason: string;
  vaultId: any;
};
export type proGrantMutationsRevokeProMutation$data = {
  readonly revokePro: {
    readonly proUntil: any;
    readonly vaultId: any;
  };
};
export type proGrantMutationsRevokeProMutation = {
  response: proGrantMutationsRevokeProMutation$data;
  variables: proGrantMutationsRevokeProMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reason"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vaultId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "reason",
        "variableName": "reason"
      },
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "concreteType": "ProRevocationState",
    "kind": "LinkedField",
    "name": "revokePro",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vaultId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "proUntil",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "proGrantMutationsRevokeProMutation",
    "selections": (v2/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "proGrantMutationsRevokeProMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "27df4e787eebff441f352cb412f76868",
    "id": null,
    "metadata": {},
    "name": "proGrantMutationsRevokeProMutation",
    "operationKind": "mutation",
    "text": "mutation proGrantMutationsRevokeProMutation(\n  $vaultId: UUID!\n  $reason: String!\n) {\n  revokePro(vaultId: $vaultId, reason: $reason) {\n    vaultId\n    proUntil\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4e6f9aeef0c2ac637b5209c4f1ebda9";

export default node;
